import React from 'react';
import { SmartCaptcha as YandexSmartCaptcha } from '@yandex/smart-captcha';

interface SmartCaptchaProps {
  sitekey: string;
  onSuccess: (token: string) => void;
}

const SmartCaptcha: React.FC<SmartCaptchaProps> = ({ sitekey, onSuccess }) => {
  return (
    <div >
      <YandexSmartCaptcha
        sitekey={sitekey}
        onSuccess={onSuccess}
      />
    </div>
  );
};

export default SmartCaptcha;
